<template>
  <div>
    <b-modal :active="true" :width="640">
      <div class="card" style="background-color: #eee;">
        <div class="card-header" style="background-color: #ccc;">
          <div class="card-header-title">
            Login
          </div>
          <div class="card-header-icon">
            <span class="icon">
              <i class="mdi mdi-lock"></i>
            </span>
          </div>
        </div>
        <div class="card-content">
          <div class="content">
            <b-field>
              <b-input v-model="username"
                       placeholder="Username"
                       @keydown.enter="login" />
            </b-field>

            <b-field>
              <b-input v-model="password"
                       type="password"
                       placeholder="Password"
                       @keydown.enter="login" />
            </b-field>
          </div>

          <div class="card-footer">
            <b-field>
              <div @click="login" class="button is-success is-light" style="background-color: #0e5f88; color: #eeeeee;">Login</div>
            </b-field>
          </div>
        </div>
      </div>
    </b-modal>

    <transition name="slide-up">
      <ScreenOverlay
        v-show="!hideScreenOverlay" />
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import { mapMutations } from 'vuex';
import ScreenOverlay from '@/views/ScreenOverlay.vue';

export default {
  name: 'AppView',
  components: {
    ScreenOverlay,
  },
  data() {
    return {
      username: '',
      password: '',
      hideScreenOverlay: true,
    };
  },
  methods: {
    ...mapMutations({
      SetAuthStatus: 'users/SetAuthStatus',
    }),
    async login() {
      try {
        const base64logindata = btoa(`${this.username}:${this.password}`);
        const authorization = `basic ${base64logindata}`;

        const res = await axios.post('https://www.byblio.app/api/user/login', {}, {
          headers: {
            authorization,
          },
        });

        if (res.data === 'Login enabled') {
          this.$buefy.toast.open({
            duration: 3000,
            message: res.data,
            position: 'is-bottom',
            type: 'is-success',
            queue: false,
          });

          return;
        }

        this.hideScreenOverlay = false;

        axios.interceptors.request.use((config) => {
          config.headers['authorization'] = authorization; // eslint-disable-line
          return config;
        });

        this.SetAuthStatus(true);

        this.$router.push({ path: '/' });
      }
      catch (err) {
        this.$buefy.toast.open({
          duration: 3000,
          message: err.response.data,
          position: 'is-bottom',
          type: 'is-danger',
          queue: false,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
